import { DemandIntentDocument } from 'models/demand/demand-intent-document.model'
import { BaseSignatureModel } from '@models/signature/base-signature.model'

export class DemandIntentDocumentAttachment extends BaseSignatureModel {
	date: string
	issues: string
	ordering: number
	signature: boolean
	publishedAt: string
	description: string
	signatureAt: string
	demand: DemandIntentDocument
	type: DemandIntentDocumentAttachmentType
	status: DemandIntentDocumentAttachmentStatus
	metadata: DemandIntentDocumentAttachmentMetadata

	constructor(source?: Partial<DemandIntentDocumentAttachment>) {
		super(source)

		if (source) {
			this.id = source.id
			this.date = source.date
			this.type = source.type
			this.status = source.status
			this.issues = source.issues
			this.ordering = source.ordering
			this.metadata = source.metadata
			this.signature = source.signature
			this.description = source.description
			this.publishedAt = source.publishedAt
			this.signatureAt = source.signatureAt
		}
	}
}

export class DemandIntentDocumentAttachmentMetadata {
	data?: Record<string, any>
	/** Gravados no upload: tamanho em bytes e nome original do arquivo. */
	size?: number
	filename?: string
}

export enum DemandIntentDocumentAttachmentType {
	OTHER = 1
}

export enum DemandIntentDocumentAttachmentStatus {
	ERROR = 0,
	CREATED = 1,
	REJECTED = 2,
	PUBLISHED = 3,
	ATTACHED = 4
}
